import React, { Component } from "react";
import GLOBALS from '../utils/Constants';
import UserService from './users-service';

export default class EmailService {

    static sharedInstance = EmailService.sharedInstance == null ? new EmailService() : this.sharedInstance;

    constructor(){
        //initialize
        this.credentials = UserService.sharedInstance.getStoredCredentials();
        this.auth_username = this.credentials.username;
        this.license = this.credentials.license;
        this.token = this.credentials.token;
        this.loggedInUser =  null;
    }

    getUpdatedCrendetials(){
        this.credentials = UserService.sharedInstance.getStoredCredentials();
        this.auth_username = this.credentials.username;
        this.license = this.credentials.license;
        this.token = this.credentials.token;
        this.loggedInUser =  this.credentials.loginResponse.data[0];
    }


    /*** See: Email: Send Email with Attached File in POSTMAN ***/
   async send(params){
        this.getUpdatedCrendetials();

        const data = new FormData();

        data.append("file", params.file);
        data.append("auth_username", this.auth_username);
        data.append("token", this.token);
        data.append("license", this.license);

        data.append("from_email", params.from_email);
        data.append("from_name", params.from_name);
        data.append("send_to_email", params.send_to_email);
        data.append("send_to_name", params.send_to_name);

        data.append("content", params.content);
        data.append("subject", params.subject);


        const response = await fetch(GLOBALS.SEND_EMAIL_API, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();

        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.log("Error in sending email.", error);
        }
    }

    async sendUserCredentials(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_EMAIL_USER_CREDENTIALS+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            }
        });

        const responseJson = await response.json();
        try {
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    async sendIncidentReportToEmails(params){

        this.getUpdatedCrendetials();

        const data = new FormData();

        let from_email = UserService.sharedInstance.returnEmptyIfNull(this.loggedInUser.email) ? "support@archontech.com" : this.loggedInUser.email;
        const from_name = this.loggedInUser.first_name + " " + this.loggedInUser.last_name;

        data.append("file", params.file);
        data.append("auth_username", this.auth_username);
        data.append("token", this.token);
        data.append("license", this.license);
        data.append("emails", JSON.stringify(params.emails));
        data.append("from_name", from_name);
        data.append("from_email", from_email);

        const response = await fetch(GLOBALS.EMAIL_INCIDENT_REPORT, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.log("Error in sending email.", error);
        }
    }

}